var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.78906 6.27344C7.85938 6.27344 7.92969 6.25 8 6.25C9.24219 6.25 10.25 7.25781 10.25 8.5C10.25 9.74219 9.24219 10.75 8 10.75C6.73438 10.75 5.75 9.74219 5.75 8.5C5.75 8.45312 5.75 8.38281 5.75 8.3125C5.96094 8.42969 6.21875 8.5 6.5 8.5C7.32031 8.5 8 7.84375 8 7C8 6.74219 7.90625 6.48438 7.78906 6.27344ZM12.5 5.14844C13.6016 6.15625 14.3281 7.375 14.6797 8.21875C14.75 8.40625 14.75 8.61719 14.6797 8.80469C14.3281 9.625 13.6016 10.8438 12.5 11.875C11.3984 12.9062 9.875 13.75 8 13.75C6.10156 13.75 4.57812 12.9062 3.47656 11.875C2.375 10.8438 1.64844 9.625 1.29688 8.80469C1.22656 8.61719 1.22656 8.40625 1.29688 8.21875C1.64844 7.375 2.375 6.15625 3.47656 5.14844C4.57812 4.11719 6.10156 3.25 8 3.25C9.875 3.25 11.3984 4.11719 12.5 5.14844ZM8 5.125C6.125 5.125 4.625 6.64844 4.625 8.5C4.625 10.375 6.125 11.875 8 11.875C9.85156 11.875 11.375 10.375 11.375 8.5C11.375 6.64844 9.85156 5.125 8 5.125Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallEye);
export default __webpack_public_path__ + "static/media/SmallEye.6b385c487afa9a696b3e842ab32052ac.svg";
export { ForwardRef as ReactComponent };